import { Card, Typography } from 'antd'
import { ReactNode, useState } from 'react'
import VSpace from '../../../common/VSpace'
import { DescriptionOwner, DescriptionTab, getInvoiceDescriptionHelp, getProposalDescriptionHelp } from './descriptionCardModel'

const { Text } = Typography

type Props = {
  owner: DescriptionOwner
  proposal: ReactNode
  invoice: ReactNode
}

const DescriptionCard = ({ owner, proposal, invoice }: Props) => {
  const [activeTab, setActiveTab] = useState<DescriptionTab>('proposal')

  return <Card
    title="Description"
    tabList={[
      { key: 'proposal', tab: 'Proposal' },
      { key: 'invoice', tab: 'Invoice' },
    ]}
    activeTabKey={activeTab}
    onTabChange={key => setActiveTab(key as DescriptionTab)}
  >
    <div hidden={activeTab !== 'proposal'}>
      <VSpace size="large">
        <Text type="secondary">{getProposalDescriptionHelp(owner)}</Text>
        {proposal}
      </VSpace>
    </div>
    <div hidden={activeTab !== 'invoice'}>
      <VSpace size="large">
        <Text type="secondary">{getInvoiceDescriptionHelp(owner)}</Text>
        {invoice}
      </VSpace>
    </div>
  </Card>
}

export default DescriptionCard
